export function getBuildingGroupListItemProps(value) {
  return {
    avatar: value.avatar,
    text: value.name,
    value: value?.id,
  }
}
